var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodbean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "podbean__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#podbean__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "podbean__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c12.357 0 16 3.643 16 16s-3.643 16-16 16S0 28.357 0 16 3.643 0 16 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#podbean__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#252027",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DC742",
    d: "M16 27.167a5.04 5.04 0 1 0 0-10.08 5.04 5.04 0 0 0 0 10.08Zm10.533-13.16A12.447 12.447 0 0 0 15.98 8.2a12.43 12.43 0 0 0-10.553 5.807 1.582 1.582 0 0 1-2.18.486 1.582 1.582 0 0 1-.487-2.18 15.578 15.578 0 0 1 13.22-7.26c5.393 0 10.333 2.72 13.22 7.267a1.583 1.583 0 0 1-.487 2.18c-.793.5-1.746.193-2.18-.487v-.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DC742",
    d: "M22.94 17.807c-.52 0-1.033-.26-1.333-.727a6.615 6.615 0 0 0-5.594-3.053 6.615 6.615 0 0 0-5.593 3.053 1.583 1.583 0 0 1-2.66-1.713 9.763 9.763 0 0 1 8.26-4.507 9.78 9.78 0 0 1 8.26 4.507 1.583 1.583 0 0 1-1.327 2.44h-.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 24.767a2.64 2.64 0 1 0 0-5.28 2.64 2.64 0 0 0 0 5.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodbean);
export default __webpack_public_path__ + "static/media/podbean.f423a4039fab7949cdf35335286171d4.svg";
export { ForwardRef as ReactComponent };